export const ContractOnboardingStrings =
{
    mapLoadError: "No se ha podido mostrar el mapa de configuración del plan. Si el problema persiste, ponte en contacto con info@ironia.tech para informarnos de esto. Disculpa las molestias",
    section1Title: "1 - Suscripción",
    section2Title: "2 - Intervinientes",
    section3Title: "3 - Verificación",
    section4Title: "4 - Tu Cartera",
    section2MoreSteps: "Intervinientes. Más pasos...",
    portfolioPlanTitle: "Plan de Cartera",
    expandAllSections: "Desplegar todo",
    collapseAllSections: "Recoger todo",
    planStatusConfiguring: "En configuración",
    planStatusReview: "En revisión",
    planStatusNotValidated: "No validado",
    planStatusActive: "Activo",
    planStatusExpired: "Caducado",
    planStatusCancelled: "Cancelado",
    planStatusUnknown: "Desconocido",
    go: "Ir",
    buy: "Comprar",
    goToTransfers: "Ir a Traspasos",
    buyFundsTaskTitle: "Comprar fondos",
    transferFundsTaskTitle: "Traspasar fondos",
    transferFundsTaskDescription: "Puedes traspasar a tu cuenta fondos de otras entidades.",
    distributorSwitchTaskTitle: "Cambio de Comercializador",
    distributorSwitchTaskDescription: "Puedes traspasarte a tu cuenta fondos de otra entidad sin que dejen de cotizar ningún día.",
    // Vista previa de la sección 4 mientras el plan aún no está en 4.1.
    portfolioOperationsPreviewDescription: "Cuando tu plan esté activo podrás realizar estas operaciones con tu cartera.",
    addOrModify: "Añadir - Modificar",
    chooseSubscription: "Elige Suscripción",
    selectInterveners: "Seleccionar",
    review: "Revisar",
    resubscribe: "Volver a Suscribirte",
    supportEmail: "info@ironia.tech",
    reviewAdvanceFailed: "No se ha podido volver al flujo de corrección.",
    viewGuide: "Ver guía",
    stepFallbackTitle: (key: string) => `Paso ${key}`,
    blockedStepPending: (stepKey: string, stepTitle: string) => `Pendiente: completa antes el paso ${stepKey} · ${stepTitle}.`,
    blockedStepPendingUnknown: "Este paso se activará cuando completes los pasos anteriores.",
    identitiesBanner: (savingsPlanName: string) => `Estás añadiendo intervinientes para el plan ${savingsPlanName} . Cuando finalices, pulsa en "Continuar con el contrato" para avanzar al siguiente paso.`,
    continueContract: "Continuar con el contrato",
    continueContractFallbackError: "No se ha podido continuar con el contrato.",
    retry: "Reintentar",
    managementAuthorizationLoadError: "No se ha podido cargar la información de la autorización de gestión.",
    // SignatureComponent pinta alreadySignedText en cuanto signed=true, antes de saber si el avance
    // del paso ha ido bien. En flujo de contrato no podemos decir "Enhorabuena, ya tienes tu plan".
    managementAuthorizationSignaturesRegistered: "Las firmas se han registrado correctamente.",
    managementAuthorizationSignedAdvanceFailed: "Las firmas se han registrado, pero no se ha podido avanzar el contrato.",
    identitiesBackToMap: "Volver al mapa",
    completeMinorToAdultData: "Completar datos",
    goToSavingsPlans: "Ir a mis planes",
    minorToAdultDataDescription: (fullName: string) => `${fullName} ya es mayor de edad. Completa sus datos (teléfono, email, justificante de ingresos, actividad económica, cargo público y pregunta GAFI) para que pase a ser titular del plan.`,
    minorToAdultTransforming: (fullName: string) => `Los datos de ${fullName} están completos. Estamos pasándole a titular del plan...`,
    minorToAdultTransformed: (fullName: string) => `${fullName} ya es el titular del plan y continuará el contrato desde su propia cuenta: revisará los intervinientes y firmará el contrato y su KYC.`,
    minorToAdultDataIncomplete: (fullName: string) => `Todavía faltan datos de ${fullName}. Te hemos enviado un email con el enlace para completarlos.`,
    minorToAdultFailed: "No se ha podido completar el paso a mayoría de edad. Si el problema persiste, ponte en contacto con info@ironia.tech.",
    deleteIdentityContractWarning: "Atención: no solo se quita del contrato o del plan. Se elimina el interviniente de tu usuario por completo.",
    deleteIdentityContractWarningDetail: "Esta acción borra al interviniente de toda tu cuenta, no únicamente de este plan de cartera.",
    intervenerSelectionTitle: "Seleccionar intervinientes para el Contrato del Plan de Cartera",
    intervenerSelectionDescription: "Confirma o edita quiénes son los intervinientes de esta cuenta",
    intervenerSelectionOwnerHint: "Para cambiar el Titular del contrato, primero debes cambiar el rol del Titular actual a otro rol.",
    intervenerSelectionContinue: "Continuar",
    intervenerSelectionBack: "Volver al mapa",
    intervenerSelectionGoToIdentities: "Ir a la gestión de intervinientes",
    intervenerSelectionNotReady: "Los intervinientes no están listos para ser seleccionados. Debes finalizar la información de cada interviniente antes de poder incluirlo en un contrato.",
    intervenerSelectionNotifyOwner: "Notificar",
    intervenerSelectionNotifyOwnerTitle: "Pedir al propietario que actualice y firme de nuevo su KYC",
    intervenerSelectionNotifySent: "Solicitud enviada al propietario.",
    intervenerSelectionNotifyAlready: "El propietario ya tenía una solicitud pendiente.",
    intervenerSelectionNotifyFailed: "No se ha podido enviar la solicitud.",
    intervenerSelectionMinorNeedsRepresentative: "Si seleccionas a algún Menor de edad es obligatorio seleccionar al menos a un Representante Legal",
    intervenerSelectionRepresentativeNeedsMinor: "Si seleccionas a algún Representante Legal es obligatorio seleccionar al menos a un Menor de edad",
    intervenerSelectionOwnerRequired: "Debes seleccionar un único Titular. Si quieres tener más de un Titular, selecciona el resto como Cotitulares.",
    intervenerSelectionMainIdentityUnknown: "No hemos podido identificar al titular principal de tu cuenta. Por favor, ponte en contacto con info@ironia.tech.",
    intervenerSelectionMainIdentityRequired: (fullName: string) => `El usuario ${fullName} debe aparecer al menos como autorizado`,
    intervenerSelectionNotSelectableIncluded: (fullName: string) => `${fullName} no puede formar parte del contrato: sus datos están sin completar o se ha dado de baja. Márcalo como "No incluido en el contrato" o revísalo en la gestión de intervinientes.`,
    suitabilityTitle: "Test de idoneidad de la inversión",
    suitabilityContinue: "Continuar",
    suitabilityBackToMap: "Volver al mapa",
    suitabilityPerformTest: "Realizar test",
    suitabilityUpdateTest: "Actualizar test",
    suitabilityNotNeeded: "No es necesario",
    suitabilityTestExpired: "Caducado",
    suitabilityRiskPlanLabel: (order: number, name: string) => `El plan de cartera seleccionado tiene un perfil de riesgo ${order}/4 ${name}`,
    suitabilityRiskIntervenersLabel: (order: number, name: string) => `El perfil de riesgo de los intervinientes es ${order}/4 ${name}`,
    suitabilityIncompatible: "No puedes continuar: el perfil de riesgo de la cartera del plan es superior al de los intervinientes seleccionados. Elige una cartera compatible.",
    suitabilitySelectAlternative: "Cambiar a esta cartera",
    suitabilityAlternativeChanged: "Cartera actualizada. Puedes continuar con el proceso.",
    suitabilityTestsIncomplete: "Debes completar el test de idoneidad de todos los intervinientes adultos del contrato antes de continuar.",
    suitabilityAdvanceFailed: "No se ha podido avanzar al siguiente paso.",
    suitabilityRiskEvaluationFailed: "No hemos podido evaluar el perfil de riesgo en este momento. Puedes reintentarlo o continuar: la compatibilidad se comprobará al avanzar.",
    suitabilityUpdateOnlyNotice: "Tu plan ya ha superado este paso. Puedes volver a realizar el test de idoneidad de cualquier interviniente cuando lo necesites: el nuevo test queda registrado al firmarlo.",
    suitabilityRetryRiskEvaluation: "Reintentar evaluación",
};

/**
 * Tabla code → mensaje de usuario para los errores del onboarding de contrato.
 *
 *  - El backend responde con un envelope tipado (OnboardingErrorItem { code, message? }).
 *    A veces solo llega el `code` (sin `Message`), y NUNCA debemos mostrar el código en crudo.
 *  - Códigos de negocio: STEP_NOT_COMPLETE, STEP_NOT_ADVANCEABLE, STEP_MISMATCH,
 *    RISK_PROFILE_NOT_COMPATIBLE, MINOR_TO_ADULT_NOT_ELIGIBLE, y los cubos genéricos
 *    INTERVENER_OPERATION_FAILED / INTEGRATION_SERVICE_UNAVAILABLE.
 *  - Códigos sintéticos del cliente (mapAxiosErrorToOnboardingEnvelope): NOT_FOUND, FORBIDDEN,
 *    HTTP_ERROR, NETWORK_ERROR, y UNKNOWN por defecto de mapWireErrors.
 *  - Mismo enfoque que src/screen/Identities/IdentityForm/identityErrorMessages.ts.
 */
export const ContractOnboardingErrorMessages: Record<string, string> =
{
    STEP_NOT_COMPLETE: "Todavía faltan datos por completar en este paso antes de continuar.",
    STEP_NOT_ADVANCEABLE: "Este paso no se puede avanzar desde aquí. Vuelve al mapa para continuar por donde corresponde.",
    STEP_MISMATCH: "Este plan ya no está en este paso. Vuelve al mapa para continuar por donde corresponde.",
    RISK_PROFILE_NOT_COMPATIBLE: "El perfil de riesgo de la cartera no es compatible con el de los intervinientes seleccionados. Elige una cartera compatible.",
    MINOR_TO_ADULT_NOT_ELIGIBLE: "Este interviniente no cumple los requisitos para pasar de menor a mayor de edad.",
    IDENTITY_NOT_SELECTABLE_FOR_CONTRACT: "Uno de los intervinientes no puede formar parte del contrato: sus datos están sin completar o se ha dado de baja. Márcalo como \"No incluido en el contrato\" o revísalo en la gestión de intervinientes.",
    INTERVENER_OPERATION_FAILED: "No se ha podido completar la operación del interviniente. Si el problema persiste, contacta con el soporte en el botón de 'Necesitas ayuda'.",
    INTEGRATION_SERVICE_UNAVAILABLE: "El servicio de integración no está disponible en este momento. Inténtalo de nuevo más tarde.",
    NOT_FOUND: "No hemos encontrado este plan de cartera.",
    FORBIDDEN: "No tienes permiso para gestionar este plan de cartera.",
    HTTP_ERROR: "Ha ocurrido un error al procesar la solicitud. Inténtalo de nuevo.",
    NETWORK_ERROR: "No hemos podido conectar. Revisa tu conexión e inténtalo de nuevo.",
    UNEXPECTED_RESPONSE: "Respuesta inesperada del servidor. Inténtalo de nuevo.",
    UNKNOWN: "Ha ocurrido un error inesperado. Inténtalo de nuevo.",
};

/**
 * Resuelve un mensaje de usuario a partir de un error del envelope de onboarding.
 * Prioridad: mapa por `code` → `message` del servidor (ya saneado) → fallback genérico.
 * Nunca devuelve el `code` en crudo.
 */
export function resolveContractOnboardingError(error?: { code?: string; message?: string } | null, fallback?: string): string
{
    const mapped = error?.code ? ContractOnboardingErrorMessages[error.code] : undefined;
    if(mapped)
    {
        return mapped;
    }

    if(error?.message)
    {
        return error.message;
    }

    return fallback ?? ContractOnboardingStrings.continueContractFallbackError;
}

export interface ContractOnboardingStepCopy
{
    title: string;
    description: string;
    extraDescription?: string;
}

export const ContractOnboardingStepTexts: Record<string, ContractOnboardingStepCopy> =
{
    "1.1":
    {
        title: "Elige Suscripción",
        description: "Selecciona la suscripción que más se ajuste a tus necesidades. Si has seleccionado un plan Plan Gestionado o Me Gusta Decidir, la suscripción es la del Plan.",
        extraDescription: "El pago se realiza de forma puntual: selecciona tu banco y paga. Recuerda que puedes utilizar tus Elements para pagar si dispones de ellos.",
    },
    "1.2":
    {
        title: "Esperando pago",
        description: "A través de una plataforma segura de pago, esperamos a que finalices la compra de tu suscripción para poder continuar con la configuración del plan.",
    },
    "2.1":
    {
        title: "Gestiona Intervinientes",
        description: "En este paso puedes añadir o modificar todos los intervinientes que desees.",
        extraDescription: "Recuerda que necesitas tener preparado para cada interviniente una foto del DNI (anverso y reverso) y un justificante de ingresos.",
    },
    "2.2":
    {
        title: "Seleccionar Intervinientes",
        description: "Aquí puedes seleccionar el rol de cada uno de los intervinientes partícipes en este contrato.",
    },
    "2.2.2":
    {
        title: "Test de Idoneidad Interviniente",
        description: "Aquí realizarás el test de idoneidad de los intervinientes seleccionados para este contrato.",
    },
    "2.2.3":
    {
        title: "Autorización de gestión",
        description: "El resto de los intervinientes deben firmar la autorización de gestión en la plataforma.",
    },
    "2.3":
    {
        title: "Firma del Contrato",
        description: "Cada interviniente presente en el contrato debe firmar con su teléfono de firma.",
        extraDescription: "Los intervinientes creados aquí obtendrán también su documento KYC en este paso."
    },
    "2.2.1":
    {
        title: "Paso a mayoría de edad",
        description: "Un interviniente menor ha alcanzado la mayoría de edad y va a pasar a ser el titular del plan.",
    },
    "2.4":
    {
        title: "Paso a mayoría de edad · Validado",
        description: "El paso a mayoría de edad está en marcha. A partir de aquí se repiten los pasos del contrato con el nuevo titular.",
    },
    "2.4.1":
    {
        title: "Paso a mayoría de edad · Datos",
        description: "El interviniente que ha alcanzado la mayoría de edad debe completar sus datos (teléfono, email, justificante de ingresos, actividad económica, cargo público y pregunta GAFI) para pasar a ser titular del plan.",
    },
    "2.4.2":
    {
        title: "Paso a mayoría de edad · Intervinientes",
        description: "Revisión de los intervinientes del contrato tras el paso a mayoría de edad. Forma parte del proceso de paso a mayoría de edad.",
    },
    "2.4.3":
    {
        title: "Paso a mayoría de edad · Test de idoneidad",
        description: "Test de idoneidad dentro del proceso de paso a mayoría de edad.",
    },
    "2.4.4":
    {
        title: "Paso a mayoría de edad · Autorización de gestión",
        description: "Autorización de gestión dentro del proceso de paso a mayoría de edad.",
    },
    "2.4.5":
    {
        title: "Paso a mayoría de edad · Firma",
        description: "El nuevo titular debe firmar el contrato y su documento KYC con su teléfono de firma.",
    },
    "3.1":
    {
        title: "Verificamos",
        description: "IronIA Fintech verifica toda la información y, si todo está correcto, procede a crear el contrato.",
    },
    "3.2":
    {
        title: "No validado",
        description: "Ironia ha detectado alguna incongruencia en los datos del contrato que debes revisar. Pulsa el botón para volver al flujo y corregirlos antes de volver a enviarlo a revisar.",
    },
    "3.3":
    {
        title: "No validado",
        description: "Ironia ha detectado alguna incongruencia en los datos del contrato que debes revisar. Pulsa el botón para volver al flujo y corregirlos antes de volver a enviarlo a revisar.",
    },
    "4.1":
    {
        title: "Plan Activo",
        description: "Tu plan de cartera está activo. Estas son algunas de las operaciones que puedes realizar.",
    },
    "4.2":
    {
        title: "Plan Caducado",
        description: "Tu plan está caducado. Debes renovar la suscripción para poder seguir operando con tu cartera.",
    },
    "4.3":
    {
        title: "Plan Cancelado",
        description: "Este plan de cartera está cancelado. Para tramitar su recuperación, ponte en contacto con nosotros en ",
    },
};

export function getContractOnboardingStepCopy(key: string): ContractOnboardingStepCopy
{
    const known = ContractOnboardingStepTexts[key];
    if(known)
    {
        return known;
    }

    return{
        title: ContractOnboardingStrings.stepFallbackTitle(key),
        description: "",
    };
}